
var carousel = function carousel() {

	var $ = require('jquery');
	require('jquery-unslider');


	var options = {
		autoplay: true,
		nav: true,
		speed: 1000,
		delay: 6000,
		infinite: true,
		arrows: false,
	};

	var $slider = $(".carousel").unslider(options);

	$('.prev').click(function() {
    	$slider.data('unslider').prev();
    });

  	$('.next').click(function() {
    	$slider.data('unslider').next();
	});

	$slider.on('mouseover', function() {
	    $slider.data('unslider').stop();
	}).on('mouseout', function() {
	    $slider.data('unslider').start();
	});

}
module.exports = carousel